//@ts-nocheck
export const API_URL_AUTH = `${config.VITE_AUTH_URL}/api/smart-safe-school-v1/`
export const API_URL_STORE = `${config.VITE_STORE_URL}/api/`
export const API_URL_CATALOG = `${config.VITE_CATALOG_URL}/api/`
export const API_URL_MEDIA = `${config.VITE_MEDIA_URL}/api/`
export const API_URL_STORAGE = config.VITE_STORAGE_URL as string
export const API_URL_WORKSHOPS = `${config.VITE_WORKSHOPS_URL}/api/`
export const API_SUPPORT_URL = `${config.VITE_SUPPORT_URL}/api/support/`
export const VENDOR_URL = config.VITE_VENDOR_URL as string
export const PUBLIC_URL = `${config.VITE_STATIC_RES_URL}/`
export const MANAGER_URL = config.VITE_MANAGER_URL as string
export const STORE_URL = config.VITE_STORE_SITE_URL as string
export const SCHOOL_URL = config.VITE_SCHOOL_URL as string
export const LMS_URL = config.VITE_LMS_URL as string

export const KEY_STRIPE = config.VITE_PK_STRIPE
